import { render, staticRenderFns } from "./MobileNewsDetails.vue?vue&type=template&id=461bd623&scoped=true&"
import script from "./MobileNewsDetails.vue?vue&type=script&lang=js&"
export * from "./MobileNewsDetails.vue?vue&type=script&lang=js&"
import style0 from "./MobileNewsDetails.vue?vue&type=style&index=0&id=461bd623&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461bd623",
  null
  
)

export default component.exports